import React, { useState } from "react";
import { Save, Send, Download, RefreshCw, Crop, ChevronDown, ChevronUp, MinusCircle, PlusCircle } from "lucide-react";
import { Sparkles, Briefcase, Layout, Minus, Palette, Crown } from "lucide-react";

export default function ImageGenerator({
    base_64,
    send,
    save,
    download,
    reGenerateImage,
    generateImageBase64,
    generate,
    not,
    setNot,
    description_image,
    setDescriptionImage,
    styleImage,
    setStyleImage,
    shapeImage,
    setShapeImage,
    setShowResizeModal,
    setUpdatedModal,
    position, setPosition,
    useLogo, setUseLogo
}) {

    const logoToggleStyles = {
        container: {
            display: "flex",
            alignItems: "center",
            gap: 12,
            cursor: "pointer",
        },
        switch: {
            position: "relative",
            width: 50,
            height: 26,
            borderRadius: 14,
            transition: "background 0.3s",
            flexShrink: 0,
            background: "#4B5563", // OFF state color (dark gray)
        },
        switchOn: {
            background: "linear-gradient(135deg, #FFB347, #FF7A00)", // ON state gradient
        },
        knob: {
            position: "absolute",
            top: 2,
            width: 22,
            height: 22,
            borderRadius: "50%",
            background: "#fff",
            boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
            transition: "left 0.3s",
        },
        label: {
            fontSize: 14,
            fontWeight: 600,
            color: "#E5E7EB",
        },
    };



    // Add this at the top inside your component

    const [logoDropdownOpen, setLogoDropdownOpen] = useState(false);

    const logoPositions = [
        "top-left",
        "top-center",
        "top-right",
        "bottom-left",
        "bottom-center",
        "bottom-right",
    ];

    const [generated, setGenerated] = useState(true);
    const [open, setOpen] = useState(false);

    const isMobile = window.innerWidth < 768;

    const styles = {
        page: {
            width: "100%",
            minHeight: "100vh",
            background: "#0B0F14",
            padding: isMobile ? "20px 16px" : "32px 40px",
            boxSizing: "border-box",
            fontFamily: "Inter, sans-serif",
            color: "#fff",
        },
        label: { fontSize: 18, fontWeight: 600, marginBottom: 10, textAlign: "left" },
        textarea: {
            width: "100%",
            minHeight: 90,
            background: "#ECFFFF",
            borderRadius: 10,
            border: "2px solid #4EEFEF",
            padding: 16,
            fontSize: 16,
            outline: "none",
            boxSizing: "border-box",
            marginBottom: 6,
        },
        counter: { fontSize: 13, color: "#9CA3AF", marginBottom: 28, textAlign: "left" },
        row: { display: "flex", gap: 32, alignItems: "flex-start", marginBottom: 28, flexDirection: isMobile ? "column" : "row" },
        styleGrid: { display: "grid", gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(auto-fill, minmax(140px, 1fr))", gap: isMobile ? 10 : 12 },
        styleCard: {
            height: 56,
            background: "#121821",
            border: "2px solid #2B3440",
            borderRadius: 10,
            display: "flex",
            alignItems: "center",
            gap: 10,
            padding: "0 14px",
            cursor: "pointer",
            fontSize: isMobile ? 13 : 14,
            fontWeight: 600,
            color: "#D1D5DB",
        },
        styleCardActive: {
            background: "#2A1A06",
            borderColor: "#F7941D",
            color: "#F7941D",
        },
        fieldWrapper: { position: "relative", width: "100%", marginBottom: 18 },
        dropdown: {
            width: "100%",
            borderRadius: 14,
            border: "2px solid #2B3440",
            padding: isMobile ? "12px 14px" : "14px 18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            background: "#0F1419",
            color: "#fff",
            boxSizing: "border-box",
        },
        dropdownMenu: {
            position: "absolute",
            top: 60,
            left: 0,
            width: "100%",
            background: "#0F1419",
            borderRadius: 14,
            border: "2px solid #2B3440",
            maxHeight: isMobile ? 180 : 220,
            overflowY: "auto",
            zIndex: 20,
        },
        dropdownItem: {
            padding: isMobile ? "12px 14px" : "14px 16px",
            fontSize: isMobile ? 14 : 15,
            cursor: "pointer",
            color: "#E5E7EB",
            borderBottom: "1px solid #1F2937",
            textAlign: "left",
        },
        dropdownItemActive: {
            background: "linear-gradient(90deg, #EE4037, #F7941D)",
            color: "#fff",
            fontWeight: 600,
        },
        generateBtn: {
            width: "100%",
            height: 64,
            background: "#F7941D",
            borderRadius: 12,
            border: "none",
            fontSize: 22,
            fontWeight: 700,
            cursor: "pointer",
            color: "#000",
            marginTop: 20,
        },
        resultCard: {
            marginTop: 40,
            background: "#121821",
            borderRadius: 14,
            border: "1px solid #2B3440",
            overflow: "hidden",
        },
        resultHeader: {
            padding: "16px 20px",
            borderBottom: "1px solid #2B3440",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: isMobile ? "wrap" : "nowrap",
            gap: isMobile ? 8 : 0,
        },
        resultTitle: { fontSize: 18, fontWeight: 700 },
        actions: {
            display: "flex",
            gap: 8,
            flexWrap: isMobile ? "wrap" : "nowrap",
            justifyContent: isMobile ? "center" : "flex-end",
        },
        gradientBtn: {
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: "linear-gradient(135deg, #FFB347, #FF7A00)",
            color: "#000",
            border: "none",
            borderRadius: 10,
            padding: isMobile ? "8px 10px" : "10px 16px",
            fontSize: isMobile ? 13 : 14,
            fontWeight: 700,
            cursor: "pointer",
            flex: isMobile ? "1 1 45%" : "initial",
        },
        iconGradient: {
            width: isMobile ? 20 : 28,
            height: isMobile ? 20 : 28,
            borderRadius: 8,
            background: "linear-gradient(135deg, #FFB347, #FF7A00)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#000",
        },
        darkBtn: {
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: "#121821",
            color: "#E5E7EB",
            border: "1px solid #2B3440",
            borderRadius: 10,
            padding: isMobile ? "8px 10px" : "10px 16px",
            fontSize: isMobile ? 13 : 14,
            fontWeight: 600,
            cursor: "pointer",
            flex: isMobile ? "1 1 45%" : "initial",
        },
        imageArea: {
            width: "100%",
            height: 420,
            background: "#0B0F14",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#6B7280",
            fontSize: 16,
        },
        splitImageArea: {
            display: "flex",
            gap: 12,
            height: "520px",   // 🔥 increased
            padding: 12,
        },

        leftPane: {
            flex: 1,
            background: "#111",
            borderRadius: 12,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        },

        rightPane: {
            flex: 1,
            background: "#111",
            borderRadius: 12,
            display: "flex",
            flexDirection: "column",
        },

        paneTitle: {
            fontSize: 13,
            opacity: 0.7,
            marginBottom: 6,
        },

        previewImage: {
            maxWidth: "95%",
            maxHeight: "95%",
            objectFit: "contain",
        },
        editorCanvas: {
            width: "100%",
            height: "450px",   // 🔥 bigger edit area
            borderRadius: 12,
            border: "1px dashed #333",
            cursor: "crosshair",
            background: "#000",
        },

        editorControls: {
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginTop: 8,
        },

        palette: {
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 8,
        },

        colorDot: {
            width: 22,
            height: 22,
            borderRadius: "50%",
            cursor: "pointer",
        },

    };

    const stylesList = [
        { label: "No Style", icon: Sparkles },
        { label: "Professional", icon: Briefcase },
        { label: "Modern", icon: Layout },
        { label: "Minimalist", icon: Minus },
        { label: "Vibrant", icon: Palette },
        { label: "Elegant", icon: Crown },
    ];

    const shapes = [
        "Boom Display (16:9)",
        "Facebook Post (4:5)",
        "Instagram Post (1:1)",
        "Landscape (16:9)",
        "Portrait (9:16)",
        "Square (1:1)",
        "TikTok/Stories (9:16)",
        "YouTube Thumbnail (16:9)"
    ];

    const [openI, setOpenI] = useState(false);


    return (
        <div style={styles.page}>
            {/* Prompt */}
            <div>
                <div style={styles.label}>Describe what you want to create</div>
                <textarea
                    style={styles.textarea}
                    value={description_image}
                    maxLength={500}
                    onChange={(e) => setDescriptionImage(e.target.value)}
                />
                <div style={styles.counter}>{description_image.length}/500 characters</div>
            </div>

            {/* Negative */}
          

            <div>
                {/* Title + Icon */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                    }}
                    onClick={() => setOpenI(!openI)}
                >
                    <div style={styles.label}>
                        What don't you want in this image?
                    </div>

                    {openI ? (
                        <MinusCircle size={20} color="#F7941D" />
                    ) : (
                        <PlusCircle size={20} color="#F7941D" />
                    )}
                </div>

                {/* Smooth collapse */}
                <div
                    style={{
                        overflow: "hidden",
                        transition: "all 0.35s ease",
                        maxHeight: openI ? 220 : 0,
                        opacity: openI ? 1 : 0,
                        transform: openI ? "translateY(0)" : "translateY(-6px)",
                    }}
                >
                    <textarea
                        style={styles.textarea}
                        value={not}
                        maxLength={500}
                        onChange={(e) => setNot(e.target.value)}
                    />

                    <div style={styles.counter}>
                        {not.length}/500 characters
                    </div>
                </div>
            </div>

            {/* Style + Shape */}
            <div style={styles.row}>
                {/* Style */}
                <div style={{ flex: 1 }}>
                    <div style={styles.label}>Choose a style</div>
                    <div style={styles.styleGrid}>
                        {stylesList.map(({ label, icon: Icon }) => (
                            <div
                                key={label}
                                onClick={() => setStyleImage(label)}
                                style={{
                                    ...styles.styleCard,
                                    ...(styleImage === label ? styles.styleCardActive : {})
                                }}
                            >
                                <Icon size={isMobile ? 14 : 18} />
                                <span>{label}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Shape */}
                <div style={{ width: isMobile ? "100%" : 300 }}>
                    <div style={styles.label}>Choose Shape</div>
                    <div style={styles.fieldWrapper}>
                        <div style={styles.dropdown} onClick={() => setOpen(!open)}>
                            <span style={{ color: open ? "#fff" : "#9CA3AF" }}>
                                {shapeImage || "Choose Shape..."}
                            </span>
                            <ChevronDown size={18} color="#F7941D" />
                        </div>
                        {open && (
                            <div style={styles.dropdownMenu}>
                                {shapes.map((item) => (
                                    <div
                                        key={item}
                                        onClick={() => { setShapeImage(item); setOpen(false); }}
                                        style={{
                                            ...styles.dropdownItem,
                                            ...(shapeImage === item ? styles.dropdownItemActive : {})
                                        }}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>


            <div style={{ marginTop: 20, marginBottom: 12 }}>
                <div style={styles.label}>Add Logo to your image?</div>

                <div
                    style={logoToggleStyles.container}
                    onClick={() => setUseLogo(!useLogo)}
                >
                    {/* Toggle switch */}
                    <div
                        style={{
                            ...logoToggleStyles.switch,
                            ...(useLogo ? logoToggleStyles.switchOn : {}),
                        }}
                    >
                        <div
                            style={{
                                ...logoToggleStyles.knob,
                                left: useLogo ? 26 : 2, // move knob to right if ON
                            }}
                        />
                    </div>

                    {/* Label */}
                    <span style={logoToggleStyles.label}>
                        {useLogo ? "Logo Enabled" : "Logo Disabled"}
                    </span>
                </div>

                {/* Logo position dropdown */}
                {useLogo && (
                    <div style={{ width: 200, marginTop: 8, position: "relative" }}>
                        <div
                            style={styles.dropdown}
                            onClick={() => setLogoDropdownOpen(!logoDropdownOpen)}
                        >
                            <span style={{ color: position ? "#fff" : "#9CA3AF" }}>
                                {position ? position.replace("-", " ") : "Choose Logo Position..."}
                            </span>
                            <ChevronDown size={18} color="#F7941D" />
                        </div>
                        {logoDropdownOpen && (
                            <div style={styles.dropdownMenu}>
                                {logoPositions.map((pos) => (
                                    <div
                                        key={pos}
                                        onClick={() => {
                                            setPosition(pos);
                                            setLogoDropdownOpen(false);
                                        }}
                                        style={{
                                            ...styles.dropdownItem,
                                            ...(position === pos ? styles.dropdownItemActive : {}),
                                        }}
                                    >
                                        {pos.replace("-", " ")}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </div>




            {/* Generate */}
            {base_64==null && <button onClick={() => generate()} style={styles.generateBtn}>✨ Generate</button>}

            {/* Generated Image */}
            {generated && (
                <div style={styles.resultCard}>
                    <div style={styles.resultHeader}>
                        <div style={styles.resultTitle}>Generated Image</div>
                        <div style={styles.actions}>
                            <button onClick={save} style={styles.gradientBtn}>
                                <span style={styles.iconGradient}><Save size={isMobile ? 14 : 16} /></span>
                                Save
                            </button>

                            <button onClick={send} style={styles.gradientBtn}>
                                <span style={styles.iconGradient}><Send size={isMobile ? 14 : 16} /></span>
                                Send to Live Devices
                            </button>

                            <button onClick={() => setUpdatedModal(true)} style={styles.darkBtn}>
                                <RefreshCw size={isMobile ? 14 : 16} />
                                Regenerate
                            </button>

                            <button onClick={setShowResizeModal} style={styles.darkBtn}>
                                <Crop size={isMobile ? 14 : 16} />
                                Resize
                            </button>

                            <button onClick={download} style={styles.gradientBtn}>
                                <span style={styles.iconGradient}><Download size={isMobile ? 14 : 16} /></span>
                                Download
                            </button>
                        </div>
                    </div>

                    {base_64 == null ? (
                        <div style={styles.imageArea}>AI Generated Image Preview</div>
                    ) : (
                        <div style={styles.splitImageArea}>
                            {/* LEFT SIDE – ORIGINAL IMAGE */}
                            <div style={styles.leftPane}>

                                <img
                                    src={`data:image/png;base64,${base_64}`}
                                    style={styles.previewImage}
                                    alt="original"
                                />
                            </div>

                            {/* RIGHT SIDE – EDITING CANVAS */}
                        </div>
                    )}


                </div>
            )}
        </div>
    );
}



